<template>
  <div  class=" ">
    <v-card shaped elevation="10" class="p-3  items-center">
    <div class="flex justify-center w-full" v-if="loadingChart">
      <Lynx-Spinner size="12" />
    </div>

    <div class="w-full" v-else>
      <!-- <h2 class="text-lg md:text-base text-neutral-600">Guias</h2> -->
      <div class=" flex justify-between items-center ">
        <h2 class="   flex-col text-lg md:text-base text-neutral-600">
          Guias
        </h2>
          <div class="flex absolute right-0">
        <p class="pr-3">%</p>
        <b-switch v-model="isValor" outlined> Qtd </b-switch>
      </div>

        </div>
        <div class=" flex  items-center ">
          
        <label class=" flex-col w-2/4  ">
          <Lynx-Label label="Carteiras" class=" " />
          <b-select
          placeholder="Selecione as carteiras..."
          style=" width: 80%;border-radius: 10px; border: 4px solid #0d0e46;"
          name="form-class"
           
            v-model="carteira"
            @input="fetchResumoGuias"
          >
          <!-- <option selected disabled>Selecione as carteiras...</option> -->

            <option value="">Todos</option>
            <option
              v-for="item in lista_carteiras"
              :key="item.id"
              :value="item.id"
            >
              {{ item.label }}
            </option>
          </b-select>
        </label>
        
  
        <ResumoGuiasChart :isValor="isValor" :values="dataSet" />
    </div>
    </div>
  </v-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ResumoGuiasChart from "@/views/charts/ResumoGuiasChart";
import { monthlyTaxesStatsRequest } from "@/services/requests/charts";

// import the component
import Treeselect from "@riophae/vue-treeselect";
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

export default {
  name: "ResumoGuias",

  components: { ResumoGuiasChart, Treeselect },
  data() {
    return {
      dataSet: {},
      loadingChart: true,
      carteira: null,
      isValor:false,
    };
  },
  computed: {
    ...mapGetters(["getCompetenciaDate"]),
    lista_carteiras() {
      //  return this.$store.state.carteira.lista_carteiras;

      let carteira = Object.values(this.$store.state.carteira.lista_carteiras);
      let data = [];
      for (let i = 0; i < carteira.length; i++) {
        if (carteira[i].setor == "contabilidade") {
          data.push({ id: carteira[i].id, label: carteira[i].nome });
        }
      }
      return data;
    },
  },
  methods: {
    fetchResumoGuias() {
      this.listar_carteiras();

      this.loadingChart = true;
      const dataCompetencia = this.$store.getters.getCompetenciaDate;
      const carteira = this.carteira;

      monthlyTaxesStatsRequest(dataCompetencia, carteira)
        .then((res) => {
          if (!res.data.enviado && !res.data.aguardando) return;
          this.dataSet = res.data;
        })
        .finally(() => (this.loadingChart = false));
    },

    listar_carteiras() {
      this.$store.dispatch("carteira/listar_carteiras");
    },
  },
  mounted() {
    this.fetchResumoGuias();
  },
};
</script>

<style scoped>
</style>
